import { postEstimate } from "../api/estimate";
import type { CheckVersion, CorpusSet, CostEstimate } from "../types";

export type { CostEstimate } from "../types";

export function fmtUsd(v: number): string {
  return "$" + (v >= 0.1 || v === 0 ? v.toFixed(2) : v.toFixed(3));
}

/* Projects the cost of running every check in a bundle over every email in a
   corpus — token estimation only, no LLM calls. Returns null if the corpus or
   bundle can't be found or the API is unreachable. */
export async function estimateCost(
  corpusId: string,
  checkBundleId: string,
  corpuses: CorpusSet[],
  checkVersions: CheckVersion[],
): Promise<CostEstimate | null> {
  const corpus = corpuses.find((c) => c.id === corpusId);
  const bundle = checkVersions.find((v) => v.id === checkBundleId);
  if (!corpus || !bundle) return null;
  return postEstimate({
    emails: corpus.emails.map((e) => ({
      id: String(e.id),
      subject: e.subject,
      bodyLength: (e.raw || e.subject || "").length,
      attachmentCount: (e.attachments || []).length,
      attachmentTotalChars: (e.attachments || []).reduce(
        (s, a) => s + (a.content || "").length,
        0,
      ),
    })),
    checkBundle: {
      checks: Object.entries(bundle.snap).map(([id, m]) => ({
        id,
        model: m.model,
        outTok: m.outTok,
        promptLength: (m.prompt || "").length,
      })),
    },
  });
}
